import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import { Link } from "@insite/mobius/index";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ClockIcon from "@tsesco/Icons/ClockIcon";
import FooterPhone from "@tsesco/Icons/FooterPhone";
import NewsUserIcon from "@tsesco/Icons/NewsUserIcon";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    support = "support",
    solution = "solution",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.support]: string;
        [fields.solution]: string;
    };
}

export interface NewsLetterStyles {
    titleWrapper?: InjectableCss;
    supportWrapper?: InjectableCss;
    solutionWrapper?: InjectableCss;
}

export const newsStyle: NewsLetterStyles = {
    titleWrapper: {
        css: css`
            color: ${getColor("primary")};
            font-family: "Roboto-Bold";
            font-size: 18px;
            line-height: 32px;
            display: flex;
            align-items: center;
            ${IconWrapper} {
                margin-right: 15px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 18px;
                    `,
                    css`
                        margin-top: 18px;
                    `,
                    css`
                        margin-top: 18px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    supportWrapper: {
        css: css`
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 22px;
            display: flex;
            align-items: center;
            font-family: "Roboto-Medium";
            margin-top: 15px;
            color: ${getColor("secondary")};
            ${IconWrapper} {
                margin-right: 15px;
            }
        `,
    },
    solutionWrapper: {
        css: css`
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 22px;
            display: flex;
            align-items: center;
            font-family: "Roboto-Medium";
            margin-top: 15px;
            color: ${getColor("secondary")};
            ${IconWrapper} {
                margin-right: 15px;
            }
        `,
    },
};

const styles = newsStyle;

export const newsLetterSupport: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper>
            <Typography as="p" {...styles.titleWrapper}>
                <Icon src={FooterPhone} />
                <Typography as="span">
                    <Link href="tel:1-800-318-4618"> {fields.title}</Link>
                </Typography>
            </Typography>
            <Typography as="p" {...styles.supportWrapper}>
                <Icon src={ClockIcon} /> <Typography as="span">{fields.support}</Typography>
            </Typography>
            <Typography as="p" {...styles.solutionWrapper}>
                <Icon src={NewsUserIcon} /> <Typography as="span">{fields.solution}</Typography>
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: newsLetterSupport,
    definition: {
        group: "Basic",
        displayName: "SE NewsLetter Support",
        fieldDefinitions: [
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.support,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.solution,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
